import { render } from "./upsertRightsDetailDialog.vue?vue&type=template&id=6d06e63a"
import script from "./upsertRightsDetailDialog.vue?vue&type=script&lang=js"
export * from "./upsertRightsDetailDialog.vue?vue&type=script&lang=js"

import "./upsertRightsDetailDialog.vue?vue&type=style&index=0&id=6d06e63a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__